export enum InsuranceCompanyNewOffer {//TODO get insurer list from /api/services/app/Insurer/GetInsurerNamesList
  AGRO = 'AGRO',
  Allianz = 'Allianz',
  Balcia = 'Balcia',
  Benefia = 'Benefia',
  Compensa = 'Compensa',
  Concordia = 'Concordia',
  DallBogg = 'DallBogg',
  ErgoHestia = 'Ergo Hestia',
  Euroins = 'Euroins',
  Generali = 'Generali',
  Interrisk = 'Interrisk',
  LINK4 = 'LINK4',
  MTU = 'MTU',
  PkoTowarzystwoUbezpieczenSA = 'PKO TOWARZYSTWO UBEZPIECZEŃ SA',
  Proama = 'Proama',
  PZU = 'PZU',
  Trasti = 'Trasti',
  TUW = 'TUW',
  TUZ = 'TUZ',
  UNIQA = 'UNIQA',
  Warta = 'Warta',
  WeFox = 'WeFox',
  Wiener = 'Wiener'
};